var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('img',{staticClass:"mb-12 mt-12",attrs:{"src":require('@/assets/img/MobileMedic_logo1_blackred.png'),"alt":"","width":"400"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }